import {
	faUtensils,
	faHouseFloodWater,
	faBicycle,
	faDice,
	faStore,
} from "@fortawesome/free-solid-svg-icons";

export const ODS = [
	{
		num: 1,
		color: "var(--ods1-color)",
		img: faUtensils,
		title: "Fome Zero",
		subtitle:
			"Auxiliar no combate à fome e redução de danos com foco em grupos marginalizados e em situação de rua no bairro",
		text: [
			"1.1. Realizar acordos com feirantes e supermercados para promover a distribuição adequada de alimentos de baixo valor comercial e em boas condições de consumo;",
			"1.2. Organizar grupos para produção semanal de marmitas e distribuição em acordo com a Política Nacional de Alimentação e Nutrição (PNAN);",
			"1.3. Revitalização de espaços coletivos subutilizados para construção de hortas urbanas no bairro.",
		],
	},
	{
		num: 2,
		color: "var(--ods2-color)",
		img: faHouseFloodWater,
		title: "Enchentes Urbanas",
		subtitle:
			"Criar mecanismos comunitários para prevenção e redução de danos relacionados aos eventos de enchentes urbanas no bairro",
		text: [
			"2.1. Mobilizar e construir comprometimento coletivo dos moradores do bairro para o correto acondicionamento do lixo, evitando a poluição das ruas;",
			"2.2. Solicitar ao poder público a regular limpeza de bueiros e galerias em estado crítico;",
			"2.3. Exigir um plano de drenagem eficiente, em consonância com o Plano Diretor Municipal, o Código Florestal e a Agenda 21;",
			"2.4. Construir canais de comunicação e plano de emergência comunitário para reduzir danos e perdas (humanas e materiais);",
			"2.4.1. Criar um cadastro de motoristas e estabelecimentos que se disponibilizam a auxiliar na logística necessária para a remoção de bens e pessoas em eventos de enchente.",
		],
	},
	{
		num: 3,
		color: "var(--ods3-color)",
		img: faBicycle,
		title: "Mobilidade Urbana",
		subtitle:
			"Engajar os moradores do bairro e o poder público para garantir o acesso à cidade de forma segura, acessível e sustentável",
		text: [
			"3.1. Mobilizar todos os moradores do bairro pela reforma de suas calçadas, levando em conta nivelamento padrão oficial e rampas de acesso;",
			"3.2. Organizar grupos de caronas no bairro como forma de reduzir o impacto da baixa cobertura de transporte coletivo;",
			"3.3. Exigir o cumprimento da Política Nacional de Mobilidade Urbana, com especial cobrança pela garantia de meios que viabilizem o transporte ativo (como caminhadas e bicicletas).",
		],
	},
	{
		num: 4,
		color: "var(--ods4-color)",
		img: faDice,
		title: "Lazer",
		subtitle:
			"Promover a sucessiva apropriação do espaço público pelos moradores do bairro, com amplição dos espaços de descanso e lazer e fomento à gestão comunitária",
		text: [
			"4.1. Congregar profissionais especialistas das áreas de engenharia, arquitetura e desenvolvimento sustentável para planejar e projetar, de forma voluntária e conjunta, uma proposta de praça comunitária autogerida;",
			"4.1.1. Construir coletivamente um plano semanal de atividades a serem desenvolvidas pelos próprios moradores na praça, incluindo exercícios físicos, atividades lúdicas e apresentações artísticas – priorizando os interesses coletivos manifestados.",
		],
	},
	{
		num: 5,
		color: "var(--ods5-color)",
		img: faStore,
		title: "Consumo consciente",
		subtitle:
			"Fomentar o consumo local consciente e desenvolver mecanismos de resiliência econômica para o pequeno produtor e comerciante do bairro",
		text: [
			"5.1. Desenvolver um website com materiais e mapas coletivos que rastreiam e compilam informações sobre feiras urbanas e pequenos produtores e comerciantes da região;",
			"5.1.1. A plataforma deve conter campos específicos para cadastro livre individual ou comercial e, como estratégia de fomento, deverão ser disponibilizados formulários para submissão propostas de parcerias e patrocínios.",
		],
	},
];
